import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Avatars from '../Avatars';

const SpeakerAvatars = ({ speakers, size }) => {
  return <Avatars users={speakers} size={size} imageKey="thumbnail" />;
};

SpeakerAvatars.defaultProps = {
  size: undefined,
};

SpeakerAvatars.propTypes = {
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive']),
  speakers: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default connect((state, props) => ({
  speakers: props.speakerIds.map((id) => state.speakers.speakersById[id]).filter((v) => v),
}))(SpeakerAvatars);
